import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { Text } from '../../../components/blocks';

type Props = {
  img?: string;
  name?: string;
  description?: string;
};

const Root = styled.div<Props>`
  display: flex;
  gap: ${({ theme }) => theme.spaces.l};
  padding: ${({ theme }) => theme.spaces.l};
  border: 2px solid ${({ theme }) => theme.borderColors.default};
  background-color: ${({ theme }) => theme.backgroundColors.white};
  margin-bottom: ${({ theme }) => theme.spaces.xl};
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spaces.s};
`;

const Img = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 1px solid ${({ theme }) => theme.borderColors.default};
  border-radius: ${({ theme }) => theme.radii.circle};
`;

export const InfoBox: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root>
      <Img>
        <img src={props.img} width="32px" height="32px" alt="Dentis編集部" />
      </Img>
      <Info>
        <Text fontWeight="bold" size="xs" color="lightgrey">
          記事監修
        </Text>
        <Text fontWeight="bold">{props.name}</Text>
        <Text size="s" lineHeight="m">
          {props.description}
        </Text>
      </Info>
    </Root>
  );
};
